<template>
  <div class="page-template" v-loading="loading">
    <el-tabs v-model="activeTab" @tab-click="tabChange">
      <el-tab-pane label="历史往来账款" name="allAccount">
        <search-form-template
          ref="searchOptions"
          :searchOptions="searchOptions"
          @searchSubmit="searchSubmit"
          @clear="clearSearch"
          :toolConfig="toolConfig"
          @btnCommon="exportExcel"
        ></search-form-template>
        <table-template ref="allAccount" :tableOptions="allAccount"></table-template>
      </el-tab-pane>
      <el-tab-pane label="应付账款明细" name="UnpaidAccount">
        <search-form-template
          ref="searchOptions"
          :searchOptions="searchOptions"
          @searchSubmit="searchSubmit"
          @clear="clearSearch"
          :toolConfig="toolConfig"
          @btnCommon="exportExcel"
        ></search-form-template>
        <table-template ref="UnpaidAccount" :tableOptions="UnpaidAccount"></table-template>
      </el-tab-pane>
      <el-tab-pane label="已付账款明细" name="payAccount">
        <search-form-template
          ref="searchOptions"
          :searchOptions="searchOptions"
          @searchSubmit="searchSubmit"
          @clear="clearSearch"
          :toolConfig="toolConfig"
          @btnCommon="exportExcel"
        ></search-form-template>
        <table-template ref="payAccount" :tableOptions="payAccount"></table-template>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
  import searchFormTemplate from '@/components/template/searchFormTemplate';
  import tableTemplate from '@/components/template/tableTemplate';
  import api from '@/config/api';

  import userPower from '@/mixin/userPower'

  export default {
    mixins: [userPower],
    name: 'RoleManager',
    components: {
      tableTemplate,
      searchFormTemplate,
    },
    data() {
      return {
        activeTab: 'allAccount',
        loading: false,
        treeConfig: {
          id: 'menuTree',
          showCheckbox: true,
          data: [],
          nodeKey: 'id',
          defaultProps: {
            children: 'children',
            label: 'name'
          },
          request: {
            api: api.system.rolePrivilege,
            param: {roleId: ''}
          }
        },
        // 高级搜索条件
        searchOptions: {
          simple: [{label: '', prop: 'purchaseOrderNo', type: 'input', placeholder: '单号'}],
          complex: [
            {
              label: '选择日期',
              prop: 'CreateDttm',
              type: 'dateTimeRangeButton',
              dateType: 'datetime',
              span: 24
            },
            {
              label: "门店名称",
              type: "select",
              prop: "storeId",
              span: 6,
              data: [],
              isHasAll: true,
              change: this.storeChange,
              url: api.system.seStore
            },
            {
              label: '供应商',
              type: 'select',
              prop: 'supplierId',
              data: [],
              span: 6,
            },
          ]
        },
        // 更多功能
        toolConfig: [
          {
            label: '打印',
            code: 'print'
          },
          {
            label: '导出',
            code: 'export',
            callback: this.exportExcel
          }
        ],
        // 历史账款
        allAccount: {
          indexShow: true,//是否显示索引
          param: {},
          showSummary: true,
          summaryColumns: ['payAmount', 'amountPaid', 'discountedAmount', 'outstandAmount'],
          columns: [
            {
              label: '门店',
              prop: 'storeName',
              width: '150',
              align: 'center'
            },
            {
              label: '供应商',
              prop: 'supplierName',
              width: '150',
              align: 'center'
            },
            {
              label: '单号',
              prop: 'purchaseOrderNo',
              width: '220',
              align: 'center',
              callback: this.goOrderDetail
            }, {
              label: '单据类型',
              prop: 'purchaseType',
              width: '90',
              align: 'center',
              enumData: this.$utils.getCacheStatus('stSupplierSettlementMap.purchaseType')
            },
            {
              label: '单据日期',
              prop: 'purchaseDttm',
              width: '180',
              align: 'center'
            },
            {
              label: '对账单号',
              prop: 'billOrderNo',
              width: '220',
              align: 'center',
              callback: this.goBillOrderDetail
            },
            {
              label: '应付金额',
              prop: 'payAmount',
              width: '90',
              align: 'center'
            },
            {
              label: '实付金额',
              prop: 'amountPaid',
              width: '90',
              align: 'center'
            },
            {
              label: '优惠金额',
              prop: 'discountedAmount',
              width: '90',
              align: 'center'
            },
            {
              label: '未付金额',
              prop: 'outstandAmount',
              width: '90',
              align: 'center'
            },
            {
              label: '最后结算日期',
              prop: 'settlementDttm',
              width: '180',
              align: 'center'
            },
            {
              label: '备注',
              prop: 'remarks',
              width: '150',
              align: 'center'
            }
          ],
          url: api.settle.supplierSettlementQuery
        },
        // 应付账款明细
        UnpaidAccount: {
          indexShow: true,//是否显示索引
          showSummary: true,
          summaryColumns: ['payAmount', 'amountPaid', 'discountedAmount', 'outstandAmount'],
          param: {settlementStatusList: [10, 20]},
          columns: [
            {
              label: '门店',
              prop: 'storeName',
              width: '150',
              align: 'center'
            },
            {
              label: '供应商',
              prop: 'supplierName',
              width: '150',
              align: 'center'
            },
            {
              label: '单号',
              prop: 'purchaseOrderNo',
              width: '220',
              align: 'center',
              callback: this.goOrderDetail
            }, {
              label: '单据类型',
              prop: 'purchaseType',
              width: '90',
              align: 'center',
              enumData: this.$utils.getCacheStatus('stSupplierSettlementMap.purchaseType')
            },
            {
              label: '单据日期',
              prop: 'purchaseDttm',
              width: '180',
              align: 'center'
            },
            {
              label: '对账单号',
              prop: 'billOrderNo',
              width: '220',
              align: 'center',
              callback: this.goBillOrderDetail
            },
            {
              label: '应付金额',
              prop: 'payAmount',
              width: '90',
              align: 'center'
            },
            {
              label: '实付金额',
              prop: 'amountPaid',
              width: '90',
              align: 'center'
            },
            {
              label: '优惠金额',
              prop: 'discountedAmount',
              width: '90',
              align: 'center'
            },
            {
              label: '未付金额',
              prop: 'outstandAmount',
              width: '90',
              align: 'center'
            },
            {
              label: '备注',
              prop: 'remarks',
              width: '150',
              align: 'center'
            }
          ],
          url: api.settle.supplierSettlementQuery
        },
        // 已付账款明细
        payAccount: {
          showSummary: true,
          summaryColumns: ['actualPayAmount', 'discountMoney'],
          indexShow: true,//是否显示索引
          param: {},
          columns: [
            {
              label: '门店',
              prop: 'storeName',
              width: '150',
              align: 'center'
            },
            {
              label: '供应商',
              prop: 'supplierName',
              width: '150',
              align: 'center'
            },
            {
              label: '单号',
              prop: 'purchaseOrderNo',
              width: '220',
              align: 'center',
              callback: this.goOrderDetail
            }, {
              label: '单据类型',
              prop: 'purchaseType',
              width: '90',
              align: 'center',
              enumData: this.$utils.getCacheStatus('stSupplierSettlementMap.purchaseType')
            },
            {
              label: '应付金额',
              prop: 'payAmount',
              width: '110',
              align: 'center'
            },
            {
              label: '累计实付金额',
              prop: 'amountPaid',
              width: '110',
              align: 'center'
            },
            {
              label: '累计优惠金额',
              prop: 'discountedAmount',
              width: '110',
              align: 'center'
            },
            {
              label: '本次实付金额',
              prop: 'actualPayAmount',
              width: '110',
              align: 'center'
            },
            {
              label: '本次优惠金额',
              prop: 'discountMoney',
              width: '110',
              align: 'center'
            },
            {
              label: '未付金额',
              prop: 'outstandAmount',
              width: '110',
              align: 'center'
            },
            {
              label: '结算单号',
              prop: 'orderNo',
              width: '180',
              align: 'center',
              callback: this.goSettlementOrderDetail
            },
            {
              label: '结算日期',
              prop: 'reviewerDttm',
              width: '180',
              align: 'center'
            },
            {
              label: '备注',
              prop: 'remarks',
              width: '150',
              align: 'center'
            }
          ],
          url: api.settle.supplierSettlementComplete
        },

        stockDetailColumns: {
          statusOption: {
            prop: 'reviewerStatus',
            statusImg: {
              10: '/static/checked.png',
              20: '/static/un-check.png',
            },
            right: '200px',
            top: '30px',
          },
          span: 8,
          labelWidth: '130',
          columns: [
            {
              label: '业务单号',
              type: 'input',
              prop: 'orderNo',
            },
            {
              label: '采购门店',
              prop: 'storeName',
            },
            {
              label: '供应商',
              type: 'select',
              prop: 'supplierName',
            },
            {
              label: '门店仓库',
              type: 'select',
              prop: 'warehouseName',
            },
            {
              label: '经手人',
              prop: 'handler',
            },
            {
              label: '采购订单',
              prop: 'purchaseOrderNo',
            },
            {
              label: '来货日期',
              prop: 'goodsArriveDttm',
            },
            {
              label: '备注',
              prop: 'remarks',
            },
          ],
          tablesProp: {
            pcGoodsMapList: {
              url: api.purchase.goods + "/page",
              height: this.detailHeight,
              showSummary: true,
              indexShow: true,
              tableName: 'pcGoodsMapList',
              summaryColumns: ['goodsNum', 'giveGoodsNum', 'totalPrice'],
              columns: [
                {
                  label: '条码',
                  prop: 'barCode',
                  width: '150',
                  align: 'center',
                },
                {
                  label: '商品名称',
                  prop: 'goodsName',
                  width: '90',
                  align: 'center',
                },
                {
                  label: '规格',
                  prop: 'specs',
                  width: '60',
                  align: 'center',
                },
                {
                  label: '单位',
                  width: '60',
                  prop: 'unitName',
                  align: 'center',
                },
                {
                  label: '自编码',
                  width: '120',
                  prop: 'artNo',
                  align: 'center',
                },
                // {
                //   label: '档案进价',
                //   width: '90',
                //   prop: 'buyPrice',
                //   align: 'center',
                // },
                {
                  label: '实际入库数量',
                  width: '130',
                  prop: 'goodsNum',
                  align: 'center',
                },
                {
                  label: '赠送数量',
                  width: '90',
                  prop: 'giveGoodsNum',
                  align: 'center',
                },
                {
                  label: '进价',
                  width: '120',
                  prop: 'price',
                  align: 'center',
                },
                {
                  label: '折扣',
                  width: '90',
                  prop: 'discountRate',
                  align: 'center',
                },
                {
                  label: '小计金额',
                  width: '120',
                  prop: 'totalPrice',
                  align: 'center',
                },
                {
                  label: '生产日期',
                  prop: 'produceDttm',
                  width: '220',
                  align: 'center',
                },
                {
                  label: '零售价',
                  width: '120',
                  prop: 'retailPrice',
                  align: 'center',
                },
                {
                  label: '零售金额',
                  width: '90',
                  prop: 'salesAmount',
                  align: 'center',
                },
                {
                  label: '采购未入库数量',
                  width: '130',
                  prop: 'noStorageNum',
                  align: 'center',
                },
                {
                  label: '系统库存',
                  prop: 'inventoryNum',
                  width: '90',
                  align: 'center',
                },
                {
                  label: '备注',
                  prop: 'remarks',
                  width: '150',
                  align: 'center',
                },
              ],
            },
          },
          // 打印的列表
          printTablesProp: {
            pcGoodsMapList: {
              tableName: 'pcGoodsMapList',
              showSummary: true,
              summaryColumns: ['totalPrice'],
              columns: [
                {
                  label: '条码',
                  prop: 'barCode',
                  width: '150',
                  align: 'center',
                },
                {
                  label: '商品名称',
                  prop: 'goodsName',
                  width: '90',
                  align: 'center',
                },
                // {
                //   label: '规格',
                //   prop: 'specs',
                //   width: '90',
                //   align: 'center',
                // },
                {
                  label: '单位',
                  width: '60',
                  prop: 'unitName',
                  align: 'center',
                },
                // {
                //   label: '自编码',
                //   width: '120',
                //   prop: 'artNo',
                //   align: 'center',
                // },
                {
                  label: '零售价',
                  width: '120',
                  prop: 'retailPrice',
                  align: 'center',
                },
                {
                  label: '进货价',
                  width: '90',
                  prop: 'buyPrice',
                  align: 'center',
                },
                {
                  label: '实际入库数量',
                  width: '130',
                  prop: 'goodsNum',
                  align: 'center',
                },
                {
                  label: '采购未入库数量',
                  width: '130',
                  prop: 'noStorageNum',
                  align: 'center',
                },
                {
                  label: '赠送数量',
                  width: '90',
                  prop: 'giveGoodsNum',
                  align: 'center',
                },
                {
                  label: '小计金额',
                  width: '120',
                  prop: 'totalPrice',
                  align: 'center',
                },
              ],
            },
          },
          url: api.purchase.stock,
        },
        returnDetailColumns: {
          statusOption: {
            prop: 'reviewerStatus',
            statusImg: {
              10: '/static/checked.png',
              20: '/static/un-check.png'
            },
            right: '100px',
            top: '30px',
          },
          span: 8,
          labelWidth: "130",
          columns: [
            {
              label: '业务单号',
              type: 'input',
              prop: 'orderNo',
              disabled: true
            },
            {
              label: '采购门店',
              prop: 'storeName',
            }, {
              label: '供应商',
              type: 'select',
              prop: 'supplierName',
            }, {
              label: '仓库名称',
              type: 'select',
              prop: 'warehouseName',
            }, {
              label: '经手人',
              prop: 'handler',
              type: 'input',
            },
            {
              label: '采购入库单',
              type: 'select',
              prop: 'storageOrderNo',
              data: [],
              labelKey: 'orderNo',
            },
            {
              label: '备注',
              type: 'input',
              prop: 'remarks',
            }],
          tablesProp: {
            goodsMapList: {
              url: api.purchase.goods + "/page",
              height:this.detailHeight,
              showSummary:true,
              indexShow: true,
              tableName: "goodsMapList",
              summaryColumns: ['goodsNum', 'giveGoodsNum','totalPrice'],
              columns: [
                {
                  label: '条码',
                  prop: 'barCode',
                  type: 'more',
                  callback: this.getInfo,
                  width: '180',
                  align: "center"
                },
                {
                  label: "商品名称",
                  prop: "goodsName",
                  width: '120',
                  align: "center"
                },
                {
                  label: "规格",
                  prop: "specs",
                  width: '90',
                  align: "center"
                },
                {
                  label: '单位',
                  width: '90',
                  prop: 'unitName',
                  align: "center"
                },
                {
                  label: '自编码',
                  width: '90',
                  prop: 'artNo',
                  align: "center"
                },
                // {
                //   label: '档案进价',
                //   prop: 'buyPrice',
                //   align: "center"
                // },
                {
                  label: '数量',
                  prop: 'goodsNum',
                  type: 'inputNumber',
                  align: "center",
                  change: this.numChange
                },
                {
                  label: '赠送数量',
                  prop: 'giveGoodsNum',
                  type: 'input',
                  align: "center"
                },
                {
                  label: '进价',
                  prop: 'price',
                  type: 'input',
                  align: "center",
                  change: this.priceChange
                },
                {
                  label: '小计金额',
                  prop: 'totalPrice',
                  type: 'input',
                  align: "center"
                },
                {
                  label: '零售价',
                  prop: 'retailPrice',
                  align: "center"
                },
                {
                  label: '零售金额',
                  prop: 'salesAmount',
                  align: "center"
                },
                {
                  label: '系统库存',
                  width: '90',
                  prop: 'inventoryNum',
                  align: "center"
                },
                {
                  label: '备注',
                  prop: 'remarks',
                  width: '150',
                  align: "center"
                },
              ],
            }
          },
          // 打印的列表
          printTablesProp: {
            goodsMapList: {
              tableName: 'goodsMapList',
              showSummary: true,
              summaryColumns: ['retailPrice', 'salesAmount', 'buyPrice', 'goodsNum'],
              columns: [
                {
                  label: '条码',
                  prop: 'barCode',
                  type: 'more',
                  callback: this.getInfo,
                  width: '180',
                  align: "center"
                },
                {
                  label: "商品名称",
                  prop: "goodsName",
                  width: '120',
                  align: "center"
                },
                {
                  label: "规格",
                  prop: "specs",
                  width: '90',
                  align: "center"
                },
                {
                  label: '自编码',
                  width: '90',
                  prop: 'artNo',
                  align: "center"
                },
                {
                  label: '零售价',
                  width: '100',
                  prop: 'retailPrice',
                  align: "center"
                },
                {
                  label: '零售金额',
                  prop: 'salesAmount',
                  align: "center"
                },
                {
                  label: '进价',
                  prop: 'buyPrice',
                  align: "center"
                },
                {
                  label: '退货数量',
                  prop: 'goodsNum',
                  type: 'inputNumber',
                  align: "center",
                  change: this.numChange
                },
              ],
            },
          },
          url: api.purchase.return
        },
        billDetailColumns: {
          statusOption: {
            prop: 'reviewerStatus',
            statusImg: {
              10: '/static/checked.png',
              20: '/static/un-check.png'
            },
            right: '200px',
            top: '30px',
          },
          span: 8,
          labelWidth: "130",
          columns: [
            {
              label: '业务单号',
              prop: 'orderNo',
            }, {
              label: '供应商',
              prop: 'supplierName',
            }, {
              label: '门店',
              prop: 'storeName',
            }, {
              label: '单据金额',
              prop: 'billAmount',
            }, {
              label: '备注',
              prop: 'remarks',
            }],
          tablesProp: {
            stSupplierBillMapMVOList: {
              url: api.settle.supplierBillMap + "/page",
              indexShow: true,
              height: this.detailHeight,
              showSummary: true,
              tableName: "stSupplierBillMapMVOList",
              summaryColumns: ['payAmount'],
              columns: [
                {
                  label: '单据号',
                  prop: 'purchaseOrderNo',
                  width: '180',
                  align: "center"
                },
                {
                  label: "门店编码",
                  prop: "storeCode",
                  width: '120',
                  align: "center"
                },
                {
                  label: "门店名称",
                  prop: "storeName",
                  width: '90',
                  align: "center"
                },
                {
                  label: '单据类型',
                  width: '90',
                  prop: 'type',
                  align: "center",
                  enumData: this.$utils.getCacheStatus('stSupplierBillMap.type'),
                },
                {
                  label: '单据日期',
                  width: '125',
                  prop: 'purchaseDttm',
                  align: "center"
                },
                {
                  label: '金额',
                  width: '90',
                  prop: 'payAmount',
                  align: "center"
                },
                {
                  label: '备注',
                  prop: 'remarks',
                  width: '90',
                  align: "center"
                },
              ],
            }
          },

          // 打印的列表
          printTablesProp: {
            stSupplierBillMapMVOList: {
              tableName: 'stSupplierBillMapMVOList',
              showSummary: true,
              summaryColumns: ['payAmount'],
              columns: [
                {
                  label: '单据号',
                  prop: 'purchaseOrderNo',
                  width: '180',
                  align: "center"
                },
                {
                  label: "门店编码",
                  prop: "storeCode",
                  width: '120',
                  align: "center"
                },
                {
                  label: "门店名称",
                  prop: "storeName",
                  width: '90',
                  align: "center"
                },
                {
                  label: '单据类型名称',
                  width: '90',
                  prop: 'type',
                  align: "center",
                  enumData: this.$utils.getCacheStatus('stSupplierBillMap.type'),
                },
                {
                  label: '单据日期',
                  width: '125',
                  prop: 'purchaseDttm',
                  align: "center"
                },
                {
                  label: '付款金额',
                  width: '90',
                  prop: 'payAmount',
                  align: "center"
                },
                {
                  label: '备注',
                  prop: 'remarks',
                  width: '90',
                  align: "center"
                },
              ],
            },
          },
          url: api.settle.supplierBill
        },
        settlementDetailColumns: {
          statusOption: {
            prop: 'reviewerStatus',
            statusImg: {
              10: '/static/checked.png',
              20: '/static/un-check.png'
            },
            right: '200px',
            top: '30px',
          },
          span: 8,
          labelWidth: "130",
          columns: [
            {
              label: '业务单号',
              prop: 'orderNo',
            },
            {
              label: '供应商',
              prop: 'supplierName',
            },
            {
              label: '门店',
              prop: 'storeName',
            },

            {
              label: '开户银行',
              prop: 'bankName',
            },
            {
              label: '银行账号',
              prop: 'bankAccount',
            },
            {
              label: '付款金额',
              prop: 'billAmount',
            },

            // {
            //   label: '开始日期',
            //   prop: 'startDttm',
            // },
            // {
            //   label: '结束日期',
            //   prop: 'endDttm',
            // },
            {
              label: '备注',
              prop: 'remarks',
            },
            // {
            //   label: '销售数量',
            //   prop: 'saleNum',
            // },
            // {
            //   label: '销售额',
            //   prop: 'salesVolume',
            // },
            // {
            //   label: '销售成本',
            //   prop: 'salesCost',
            // },
          ],
          tablesProp: {
            stSupplierSettlementMapList: {
              url: api.settle.SupplierSettlementMap + "/page",
              indexShow: true,
              height: this.detailHeight,
              showSummary: true,
              tableName: "stSupplierSettlementMapList",
              summaryColumns: ['payAmount', 'amountPaid', 'discountedAmount', 'outstandAmount', 'actualPayAmount', 'discountMoney'],
              columns: [
                {
                  label: '单据号',
                  prop: 'purchaseOrderNo',
                  width: '220',
                  align: "center"
                },
                {
                  label: "单据类型",
                  prop: "purchaseType",
                  width: '120',
                  align: "center",
                  enumData: this.$utils.getCacheStatus('stSupplierSettlementMap.purchaseType')
                },
                {
                  label: "单据日期",
                  prop: "billDttm",
                  width: '180',
                  align: "center"
                },
                {
                  label: "对账单号",
                  prop: "billOrderNo",
                  width: '220',
                  align: "center",
                },
                {
                  label: '应付金额',
                  width: '90',
                  prop: 'payAmount',
                  align: "center",
                },
                {
                  label: '已付金额',
                  width: '125',
                  prop: 'amountPaid',
                  align: "center"
                },
                {
                  label: '已优惠金额',
                  width: '100',
                  prop: 'discountedAmount',
                  align: "center"
                },
                {
                  label: '未付金额',
                  width: '90',
                  prop: 'outstandAmount',
                  align: "center"
                },
                {
                  label: '实付金额',
                  width: '90',
                  prop: 'actualPayAmount',
                  align: "center",
                  min: -Infinity,
                  precision: 2
                },
                {
                  label: '优惠金额',
                  width: '90',
                  prop: 'discountMoney',
                  align: "center",
                  precision: 2
                },
                {
                  label: '备注',
                  prop: 'remarks',
                  width: '200',
                  align: "center"
                },
              ]
            },
          },

          // 打印的列表
          printTablesProp: {
            stSupplierSettlementMapList: {
              tableName: 'stSupplierSettlementMapList',
              showSummary: true,
              summaryColumns: ['payAmount'],
              columns: [
                {
                  label: '序号',
                  prop: 'indexShow',
                  width: '50',
                  align: "center"
                },
                {
                  label: '单据号',
                  prop: 'purchaseOrderNo',
                  width: '220',
                  align: "center"
                },
                {
                  label: "单据类型",
                  prop: "purchaseType",
                  width: '120',
                  align: "center",
                  enumData: this.$utils.getCacheStatus('stSupplierSettlementMap.purchaseType')
                },
                {
                  label: "单据日期",
                  prop: "billDttm",
                  width: '180',
                  align: "center"
                },
                {
                  label: "对账单号",
                  prop: "billOrderNo",
                  width: '220',
                  align: "center",
                },
                {
                  label: '应付金额',
                  width: '90',
                  prop: 'payAmount',
                  align: "center",
                },
                {
                  label: '已付金额',
                  width: '125',
                  prop: 'amountPaid',
                  align: "center"
                },
                {
                  label: '已优惠金额',
                  width: '100',
                  prop: 'discountedAmount',
                  align: "center"
                },
                {
                  label: '未付金额',
                  width: '90',
                  prop: 'outstandAmount',
                  align: "center"
                },
                {
                  label: '实付金额',
                  width: '90',
                  prop: 'actualPayAmount',
                  align: "center",
                  min: -Infinity,
                  precision: 2
                },
                {
                  label: '优惠金额',
                  width: '90',
                  prop: 'discountMoney',
                  align: "center",
                  precision: 2
                },
                {
                  label: '备注',
                  prop: 'remarks',
                  width: '200',
                  align: "center"
                },
              ]
            },
          },
          url: api.settle.supplierSettlement
        }
      };
    },
    created() {
      this.title = document.title;
      if (this.$utils.getSysUser().storeId) {
        this.storeChange(this.$utils.getSysUser())
      }
      this.setStore(this.searchOptions.complex)
    },
    mounted() {
    },
    methods: {
      goBillOrderDetail(row) {
        console.log(row);
        this.$utils.setDataByKey(this.$utils.storeKeys.FORMINFO, this.billDetailColumns);
        const {href} = this.$router.resolve({
          name: "SupplierBillDetail",
          query: {id: row.billId},
        });
        window.open(href, "_blank");
      },
      goSettlementOrderDetail(row) {
        console.log(row);
        this.$utils.setDataByKey(this.$utils.storeKeys.FORMINFO, this.settlementDetailColumns);
        const {href} = this.$router.resolve({
          name: "SettlementBillDetail",
          query: {id: row.settlementId},
        });
        window.open(href, "_blank");
      },
      goOrderDetail(row) {
        console.log(row);
        if (row.purchaseType === undefined) {
          row.purchaseType = row.type;
        }
        if (row.purchaseType === 10) {
          this.$utils.setDataByKey(this.$utils.storeKeys.FORMINFO, this.stockDetailColumns);
          const {href} = this.$router.resolve({
            name: "stockDetail",
            query: {id: row.purchaseId},
          });
          window.open(href, "_blank");
        } else {
          this.$utils.setDataByKey(this.$utils.storeKeys.FORMINFO, this.returnDetailColumns);
          const {href} = this.$router.resolve({
            name: "purchaseReturnDetail",
            query: {id: row.purchaseId},
          });
          window.open(href, "_blank");
        }
      },

      // 选择门店
      storeChange(form) {
        form.supplierId = '';
        this.$axios.fetchPost(api.archives.supplier + '/query/supplier/list', {storeId: form.storeId}).then(data => {
          if (data.code === 200) {
            this.searchOptions.complex.filter(item => item.prop === 'supplierId')[0].data = data.data;
          }
        })
      },
      // 点击重置 刷新列表
      clearSearch() {
        this.$refs['allAccount'].clearSearch();
        this.$refs['UnpaidAccount'].clearSearch();
        this.$refs['payAccount'].clearSearch();
      },
      // 点击搜索
      searchSubmit(param) {
        this.$refs[this.activeTab].searchParam = param;
        this.$refs[this.activeTab].operationSuccess();
      },
      tabChange() {
        this.$refs.searchOptions.complexClear()
        this.$refs[this.activeTab].searchParam = {}
        this.$refs[this.activeTab].operationSuccess();
      },
      exportExcel() {
        const loading = this.$loading({
          lock: true,
          text: '正在导出...',
          background: 'rgba(225, 225, 225, 0.8)'
        });
        let fileName, param;
        let url = '';
        switch (this.activeTab) {
          case 'allAccount':
            param = this.$refs["allAccount"].searchParam;
            fileName = '历史往来账款_' + this.$utils.getDateTime() + '.xls';
            url = api.settle.allSettlementExport;
            break;
          case 'UnpaidAccount':
            param = this.$refs["UnpaidAccount"].searchParam;
            param.settlementStatusList = [10, 20];
            fileName = '应付账款明细_' + this.$utils.getDateTime() + '.xls';
            url = api.settle.supplierUnpaidAccountExport;
            break;
          case 'payAccount':
            param = this.$refs["payAccount"].searchParam;
            fileName = '已付账款明细.xls' + this.$utils.getDateTime() + '.xls';
            url = api.settle.supplierPayAccountExport;
            break;
        }
        this.$axios.PostBlob(url, param).then(res => {
          if (res.status === 200) {
            let blob = new Blob([res.data])
            let downloadElement = document.createElement('a');
            let href = window.URL.createObjectURL(blob); //创建下载的链接
            downloadElement.href = href;
            downloadElement.download = fileName; //下载后文件名
            document.body.appendChild(downloadElement);
            downloadElement.click(); //点击下载
            document.body.removeChild(downloadElement); //下载完成移除元素
            window.URL.revokeObjectURL(href); //释放掉blob对象
            this.$notify({
              type: "success",
              title: '导出操作',
              message: '成功!文件名称:' + fileName,
              showClose: false,
            });
            // this.$message.success("导出成功,文件名称:" + fileName);
          } else {
            this.$notify({
              type: "error",
              title: '导出操作',
              message: '失败',
              showClose: false,
            });
            // this.$message.warning("当前导出数据为空或超出10000条。");
          }
        }).catch(() => {
          this.$message.warning("当前导出数据为空或超出10000条。");
        }).finally(() => {
          loading.close();
        });
      },
    }
  }
</script>

<style scoped>
  .page-template {
    padding-top: 0;
  }
</style>



// WEBPACK FOOTER //
// src/page/settle/query/SupplierSettlement.vue